import { getWidgetsConfig } from '~utils';

export const useCartEnabled = (): boolean => getWidgetsConfig('data-enable-cart') === 'true';
